import { ChangeEvent, ContentType, TipsBoxData } from '@bm-js/atlascloud-shared'
import { Editor } from '@tinymce/tinymce-react'
import { useRef } from 'react'
import Select from './Select'
import { marginOptions } from '@bm-js/atlascloud-ui'
import { useTr } from '../utils/useTr'
import { TrKey } from '../cnst/translations/trKey.cnst'

type Props = {
  content: ContentType<TipsBoxData>
  setData: (e: ChangeEvent) => void
}

const TipsBoxEditor = ({ content, setData }: Props) => {
  const { tr } = useTr()
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const ref = useRef<any>(null)
  return (
    <>
      <p className='m0 label'>{tr(TrKey.tipsBoxEditorTextLabel)}</p>
      {/* TODO: Externalize rich text editor to a single component */}
      <Editor
        onInit={(_evt, editor) => {
          ref.current = editor
        }}
        apiKey='8vx5y7rq8czx2uiyjxz384z1tgv52e698san9yj67z6h9z45'
        initialValue={content.data.content}
        onBlur={() => {
          const e = {
            target: {
              name: 'content',
              value: ref.current.getContent(),
            },
          }
          setData(e)
        }}
        init={{
          menubar: false,
          plugins: [
            'advlist',
            'autolink',
            'lists',
            'link',
            'image',
            'charmap',
            'preview',
            'anchor',
            'searchreplace',
            'visualblocks',
            'code',
            'fullscreen',
            'insertdatetime',
            'media',
            'table',
            'code',
            'help',
            'wordcount',
          ],

          toolbar: 'blocks | bold italic underline link  | bullist numlist |',
        }}
      />
      <Select
        light
        label={tr(TrKey.tipsBoxEditorMarginBottomLabel)}
        desc={tr(TrKey.tipsBoxEditorMarginBottomDescription)}
        id='marginBottom'
        name='marginBottom'
        value={content.data.marginBottom}
        onChange={setData}
      >
        <option value='' disabled>
          {tr(TrKey.tipsBoxEditorMarginBottomPlaceholder)}
        </option>
        {marginOptions.map((opt) => (
          <option key={`margin_option_${opt.value}`} value={opt.value}>
            {opt.name}
          </option>
        ))}
      </Select>
      <Select
        light
        label={tr(TrKey.tipsBoxEditorAlignmentLabel)}
        id='alignment'
        name='alignment'
        value={content.data.alignment}
        onChange={setData}
      >
        <option value='' disabled>
          {tr(TrKey.tipsBoxEditorAlignmentPlaceholder)}
        </option>
        <option value='left'>
          {tr(TrKey.tipsBoxEditorAlignmentOptionLeft)}
        </option>
        <option value='center'>
          {tr(TrKey.tipsBoxEditorAlignmentOptionCenter)}
        </option>
      </Select>
    </>
  )
}

export default TipsBoxEditor
